<template>
    <div class="whatsapp-chat-widget">
        <!-- WhatsApp 浮动按钮 -->
        <button 
            class="whatsapp-button" 
            @click="openWhatsApp"
            aria-label="Chat on WhatsApp"
        >
            <svg 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg" 
                class="whatsapp-icon"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                <line x1="9" y1="10" x2="15" y2="10" />
                <line x1="9" y1="14" x2="13" y2="14" />
            </svg>
            
            <!-- 未读消息提示点 (可选) -->
            <span v-if="showNotification" class="notification-dot"></span>
        </button>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

// WhatsApp 配置
const whatsappNumber = ref('8615815597437') // 替换为你的 WhatsApp 号码 (国际格式，不��� + 号)
const defaultMessage = ref('Hello! I would like to inquire about your packaging products.') // 默认消息
const showNotification = ref(false) // 是否显示未读消息提示点

// 打开 WhatsApp 聊天
const openWhatsApp = () => {
    // 编码消息
    const encodedMessage = encodeURIComponent(defaultMessage.value)
    
    // 构建 WhatsApp URL
    // 桌面端使用 web.whatsapp.com，移动端使用 api.whatsapp.com
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    const whatsappUrl = isMobile
        ? `https://api.whatsapp.com/send?phone=${whatsappNumber.value}&text=${encodedMessage}`
        : `https://web.whatsapp.com/send?phone=${whatsappNumber.value}&text=${encodedMessage}`
    
    // 在新窗口打开 WhatsApp
    window.open(whatsappUrl, '_blank')
}
</script>

<style lang="scss" scoped>
.whatsapp-chat-widget {
    position: fixed;
    bottom: 12px;
    right: 96px;
    z-index: 9999;
}

.whatsapp-button {
    position: relative;
    width: 56px;
    height: 56px;
    background: #039c3b; /* WhatsApp 绿色 */
    border: none;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    transition: all 0.3s ease;
    
    &:hover {
        transform: scale(1.1);
        box-shadow: 0 6px 20px rgba(37, 211, 102, 0.6);
    }
    
    &:active {
        transform: scale(0.95);
    }
}

.whatsapp-icon {
    width: 36px;
    height: 36px;
    color: white;
}

/* 未读消息提示点 */
.notification-dot {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 12px;
    height: 12px;
    background: #ff4444;
    border: 2px solid white;
    border-radius: 50%;
    animation: pulse 2s infinite;
}

/* 脉冲动画 */
@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 68, 68, 0.7);
    }
    70% {
        box-shadow: 0 0 0 10px rgba(255, 68, 68, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(255, 68, 68, 0);
    }
}

/* 响应式设计 */
@media (max-width: 768px) {
    .whatsapp-chat-widget {
        bottom: 8px;
        right: 80px;
    }
    
    .whatsapp-button {
        width: 52px;
        height: 52px;
    }
    
    .whatsapp-icon {
        width: 32px;
        height: 32px;
    }
}

/* 添加入场动画 */
.whatsapp-chat-widget {
    animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
    from {
        transform: translateY(100px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>
